import {filter, forEach, get, isArray, isNil, isUndefined, uniq} from 'lodash';
import {orderBy} from 'natural-orderby';
import numeral from 'numeraljs';

import Button from 'components/Button';
import TextFilter from 'components/Table/Filter/Text';
import SimpleTable from 'components/Table/Simple';
import InfoIcon from 'components/icons/Info';
import {DataSource} from 'conf/enums';
import {compareFreqSources, transformPerSource} from 'utils/frequencyUtils';

import './table.scss';

export default function AlleleFrequencyTable({frequencies, pop, customFilters}) {
  const filteredFrequencies = filter(frequencies, (f) => f.population === pop);
  const sources = uniq(filteredFrequencies.map((f) => f.dataSource)).sort(compareFreqSources);

  const columns = [
    {
      id: 'alleleText',
      Header: 'Allele Name',
      accessor: 'alleleText',
      Filter: TextFilter,
      sortable: true,
    },
  ];
  forEach(sources, (source) => {
    const Header = DataSource.shortName[source];
    columns.push({
      id: source,
      Header,
      accessor: source,
      Cell: FrequencyCell,
      getCellExportValue: getFrequencyExportValue,
      sortable: true,
      sortType: sortFrequency,
    });
  });

  const geneSymbol = frequencies[0].parent.symbol;

  const legendLink = (
    <Button href="/page/biobankFrequencies" className="btn-outline-secondary btn-sm">
      <InfoIcon className="mr-1 text-black-50" />
      More Info
    </Button>
  );

  const body = (
    <SimpleTable
      className="frequencyTable"
      columns={columns}
      data={orderBy(transformPerSource(filteredFrequencies), ['alleleText'])}
      disableExport={false}
      customFilters={customFilters}
      getExportFileName={() => `clinpgx-allele-frequency-${geneSymbol}-${pop}`}
      customButtons={legendLink}
    />
  );

  return (
    <div>
      {body}
    </div>
  );
}

function FrequencyCell({value}) {
  if (!value) {
    return null;
  }
  const {frequency} = value;
  return (
    <div className="text-right text-monospace">
      {numeral(frequency).format('0.[000]%')}
    </div>
  );
}

function getFrequencyExportValue(row, column) {
  const value = get(row.values[column.id], 'frequency', null);
  if (!value) {
    return '';
  }
  return numeral(value).format('0.[000]%');
}

export function sortFrequency(rowA, rowB, columnId) {
  const a = rowA.values[columnId]?.frequency;
  const b = rowB.values[columnId]?.frequency;

  if (isNil(a) && isNil(b)) {
    return 0;
  } else if (isNil(a)) {
    return -1;
  } else if (isNil(b)) {
    return 1;
  }
  return a - b;
}
